<template>
  <div class="hotGame">
    <!-- 导航栏 -->
    <van-nav-bar
      :border="false"
      :placeholder="true"
      :title="title"
      :fixed="true"
      z-index="10"
    >
      <van-icon
        name="arrow-left"
        slot="left"
        size=".7rem"
        color="#FF9D11"
        @click="onBack"
      />
    </van-nav-bar>
    <!-- 新游内容 -->
    <div class="game-wrapper">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="game-cont">
          <div class="dis-game" v-for="(item, index) in arrList" :key="index">
            <div
              class="i-game"
              @click="gameDateil('gamedetails', { gameid: item.gid })"
            >
              <img v-lazy="item.icon_url" />
            </div>
            <div
              class="game-des"
              @click="gameDateil('gamedetails', { gameid: item.gid })"
            >
              <div class="game-name-size">
                <span class="name">{{ item.game_name }}</span>
              </div>
              <div class="type-size">
                <span
                  v-for="(item, index) in gameType(item.game_type_name)"
                  :key="index"
                  v-show="index == 0"
                  >{{ item }}</span
                >
                <span class="line">|</span>
                <span>{{ item.package_size }}</span>
              </div>
              <div class="game-title">
                <span>{{ item.short_info }}</span>
              </div>
              <div class="dis-num">
                <span
                  v-for="(_item, index) in gameType(item.game_label)"
                  :key="index"
                  >{{ _item }}</span
                >
              </div>
            </div>
            <div class="game-down">
              <a
                v-if="item.pid != 100"
                @click.stop="downGame(item.down_url, item.pid, item.gid)"
                >下载</a
              >
              <a
                v-else
                @click.stop="downGame(item.down_url, item.pid, item.gid)"
                >开玩</a
              >
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { contTools, lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "newGame",
  mixins: [contTools, lyTool],
  data() {
    return {
      partId: this.$route.query.partId, // 地址栏partId
      page: 1, // 页数
      arrList: [],
      title: "",
      loading: false,
      finished: false,
      page: 1,
    };
  },
  computed: {
    // title: function() {
    //   switch (true) {
    //     case this.partId == 3:
    //       return "折扣专区";
    //       break;
    //     case this.partId == 4:
    //       return "热门推荐";
    //       break;
    //     case this.partId == 5:
    //       return "新游推荐";
    //       break;
    //     default:
    //       return "热门推荐";
    //       break;
    //   }
    // }
  },
  created() {},
  mounted() {
    // let H = this.$refs.navBar.height;
    // this.$refs.wrapper.style.height = window.innerHeight - H;
    // console.log( this.$refs.wrapper);
  },
  methods: {
    // 上拉加载
    onLoad() {
      let data = comTools.assignObj(this.wapConfig(), {
        part_id: this.partId,
        page: this.page,
      });
      data.sign = comTools.querySort(data);
      wapApiFun.gameMore(data).then((res) => {
        if (res.code == 200) {
          this.title = res.data.title;
          let dataList = res.data.games.data;
          this.arrList = this.arrList.concat(dataList);
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.arrList.length >= res.data.games.total) {
            this.finished = true;
            console.log("数据全部加载完成");
          }
          this.page++;
        }
      });

      // this.$refs.wrapper.finishPullUp()
    },
    onBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/com.less";
@themeC: #ff971c;
.hotGame {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /deep/.van-nav-bar__title {
    font-weight: bold;
  }
  .game-wrapper {
    width: 100%;
    height: 100%;
    .game-cont {
      width: 92%;
      background-color: #fff;
      position: relative;
      padding-bottom: 0.2rem;
      margin: 0 auto;
      margin-top: 0.6rem;
      .dis-game {
        width: 100%;
        position: relative;
        margin-bottom: 0.5rem;
        .jc-content(flex-start);
        .i-game {
          width: 18%;
          margin: 0 0.3rem;
          img {
            .img();
          }
        }
        .game-des {
          min-width: 50%;
          flex-direction: column;
          display: flex;
          .game-name-size {
            .name {
              font-size: 0.5rem;
              padding-right: 0.3rem;
            }
          }
          .type-size {
            .font-color();
            font-size: 0.25rem;
            .line {
              padding: 0 3px;
            }
          }
          // .game-type {
          //   color: #999;
          //   margin-bottom: 0.1rem;
          //   span {
          //     padding-right: 0.2rem;
          //     font-size: 0.4rem;
          //   }
          // }
          .game-title {
            width: 100%;
            color: #999;
            font-size: 0.3rem;
            // padding-bottom: 0.1rem;
            span {
              display: inline-block;
              width: 80%;
              .ellipsis();
            }
          }
          .dis-num {
            display: flex;
            span {
              font-size: 0.25rem;
              // border-radius: 0.2rem;
              // display: inline-block;
              padding: 1px 0.2rem;
              margin-right: 0.2rem;
              &:nth-of-type(1) {
                color: #d4704e;
                background-color: #feedde;
              }
              &:nth-of-type(2) {
                color: #666;
                background-color: #f5f5f5;
              }
              &:nth-of-type(3) {
                color: #d4704e;
                background-color: #feedde;
              }
            }
          }
        }
        .game-down {
          position: absolute;
          right: 0.3rem;
          top: 50%;
          transform: translate(0, -50%);
          background-color: @themeC;
          border-radius: 0.2rem;
          padding: 0.1rem 0.4rem;
          a {
            color: #fff;
          }
        }
        &:last-child {
          margin-bottom: 1.5rem;
        }
      }
      .noData {
        width: 100%;
        text-align: center;
        .font-color();
        font-size: 0.4rem;
        padding: 0.5rem 0;
      }
    }
  }
}
</style>
